import {client} from '@core/GraphQLProvider';
import {OpalescenceSignUp} from './query.graphql';

const NewsletterService = {
    async opalSubscribe ( formData ) {
        const resp = await client.mutate( {
            mutation: OpalescenceSignUp,
            variables: {input: formData}
        } );

        return resp.data.opalescenceInTheLoopSignup
    }
};

export default NewsletterService;
